<!-- 


    -------------------------------------------------

    DEPRECATED - DO NOT USE FOR NEW DEVELOPMENT

    -------------------------------------------------
    

    
-->
<template>
    <div class="field-group_item"> 
        <div class="field-group_cell field-group_cell--label">
            <BaseStack
                v-if="hasLabel"
                class="c-field__label"
                spacing="0"
            >
                <BaseInline element="label">
                    <div class="field-group_label">
                        <slot name="label"></slot>
                    </div>
            
                    <slot name="help">
                        <BaseFlyout v-if="help"
                            :bodyHTML="helpText"
                            inlinePosition="afterDense"
                            :isHelp="true"
                        />
                    </slot>
                </BaseInline>
            </BaseStack>
        </div>
        <div class="field-group_cell field-group_cell--value">
            <div class="field-group_value">
                <slot name="value"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        help:{
            type: Boolean,
            default: false
        },
        helpText: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            testprop: 'This is a test!',
        };
    }, 
    computed:{
        hasLabel(){
            return !!this.$slots.label || this.label;
        },
    },
    mounted() {

    }
};
</script>